<div class="container-fluid p-1">

  <!-- SELECTION DU TREEVIEW DANS LA COMBO -->

  <select class="form-control q-main-select w-50 widthSelect" (change)="ReloadGrid()" [(ngModel)]="fileNameForGrid">
    <option value="">Veuillez choisir une édition</option>
    <option *ngFor="let treeview of lstTreeviews" value="{{treeview.id}}">{{treeview.value}}</option>
  </select> 


  <!-- CUSTOM GRID -->
  <div *ngIf="showGrid" class="p-3 h-100 w-100">
    <div class="grid pt-0">
      <q-customgrid [customgridName]="fileNameForGrid" [idDonnee]="idDonnee" [completeWhere]="filtreWhere"></q-customgrid>
    </div>
  </div>

</div>
